import { Outlet } from "react-router-dom";

/**
 *	Layout
 */
export function Layout() {
  return <Outlet />;
}
